export default "__VITE_ASSET__B7e$_Kvo__"